var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CellGroup',_vm._l((_vm.labelList),function(item){return _c('Cell',{key:item.label,attrs:{"title":item.label}},[_c('div',{staticClass:"label_extra",attrs:{"slot":"extra"},slot:"extra"},[_vm._v(_vm._s(item.value))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }